import { SyntheticEvent } from 'react';
export interface GlobalEventInterface {
  type: string;
  action: (e: Event) => void;
}

let stopped = [];
let events = {
  click: []
};

(() => {
  window.addEventListener('click', (e) => {
    for (let lis of events.click) {
      if (stopped.indexOf(lis) === -1) {
        lis.action(e);
      } else {
        stopped.splice(stopped.indexOf(lis), 1);
      }
    }
  });
})();

export const GlobalEvents = {
  window: (window as any),
  Click: (click: (e: MouseEvent) => void): GlobalEventInterface => {
    let lis = {
      type: 'click',
      action: click
    };

    if (events.click.indexOf(lis) === -1) {
      events.click.push(lis);
    }
    return lis;
  },
  prevent: (e: GlobalEventInterface) => {
    stopped.push(e);
    return this;
  },
  stop: (e: SyntheticEvent<any>) => {
    let ev: any = e;

    if (typeof e.nativeEvent !== 'undefined') {
      ev = e.nativeEvent;
    }

    if (typeof (ev.stopImmediatePropagation) === 'function') {
      ev.stopImmediatePropagation();
    }

    return;
  },
  unBind: (event: GlobalEventInterface) => {
    if (events[event.type].indexOf(event) > -1) {
      events[event.type].splice(events[event.type].indexOf(event), 1);
    }
  }
};